(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('compactRoomGrid', function(
    $routeParams,
    scrollService,
    broker,
    hotelRoomService,
    occupancyService,
    cookieService,
    taxationService,
    analytics,
    mandatoryTransferService
) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            priceMode: '=',
            numNights: '=',
            selectRooms: '&',
            showModal: '&',
            flightCostPerPerson: '=',
            flightCostTotal: '=',
            holidayMode: '=',
            currencyCode: '@',
            roomsLeftLimit: '=',
            packagePrice: '=',
            marhabaCost: '=?',
            isKidsFree: '=',
            showCityTax: '=',
        },
        transclude: false,
        templateUrl: 'partials/home/directivetemplate?type=CompactRoomGrid',
        link(scope) {
            scope.roomGridData = [];
            scope.selectedPrices = {};
            scope.showAllRooms = false;
            scope.roomsToShow = 2;
            scope.selectSingleRoom = selectSingleRoom;
            scope.selectMultipleRooms = selectMultipleRooms;
            scope.totalRoomCosts = 0;
            scope.totalRoomCostsOriginal = 0;
            scope.showMessagePopup = false;
            scope.pickRooms = pickRooms;
            scope.moreRooms = 0;
            scope.toggleExtraRooms = toggleExtraRooms;
            scope.totalNonInfants = 0;
            scope.openImageGallery = openImageGallery;
            scope.roomImages = [];
            scope.showRoomImages = false;
            scope.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
            scope.marhabaCost = scope.marhabaCost || 0;
            scope.showDiscount = TRPCONFIG.Domain.SeasonalDeals && TRPCONFIG.Domain.SeasonalDeals.isPillVisible;
            scope.callToBookEnabled = TRPCONFIG.Domain.CallToBookEnabled;
            scope.holidayWasAmount = (p, room) =>
                p.OriginalCost / (scope.priceMode === 0 ? room.nonInfants : 1) +
                (scope.priceMode === 0 ? scope.flightCostPerPerson :
                    scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
            scope.holidayAmount = (p, room) =>
                p.Cost / (scope.priceMode === 0 ? room.nonInfants : 1) +
                (scope.priceMode === 0 ? scope.flightCostPerPerson :
                    scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
            scope.holidayDiscountPercentage = p => {
                if (!scope.packagePrice && p.DiscountPercentage > 0) {
                    return p.DiscountPercentage;
                }
            };
            scope.getBasePrice = p => {
                if (p.BoardOptions[0] && p.BoardOptions[0].Cost) {
                    return p.BoardOptions[0].Cost;
                }
                return 0;
            };
            scope.checkIsBasePrice = (base, current) => {
                if (base === current) {
                    return true;
                }
                return false;
            };

            scope.displayBoardPrice = (room, price, priceMode) => {
                return price.Cost / (priceMode === 0 ? room.nonInfants : 1) + (((scope.marhabaCost || 0) / (priceMode === 0
                    ? room.nonInfants : 1)) / (scope.roomGridData.length || 1)) + (priceMode === 0 ? scope.flightCostPerPerson
                    : scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
            };

            broker.subscribe('CompactRoomGrid', 'roomsSet', function(ev) {
                scope.hotel = ev.data;
                _restructureData();
            });

            broker.subscribe('CompactRoomGrid', 'continueToBookFromFlightDetailsModal', function(e) {
                if (e.data.multipleRoomMode) {
                    mandatoryTransferService.generateMandatoryOptions(scope.selectedPrices, e.data.flightDetails);
                    pickRooms();
                } else {
                    mandatoryTransferService.generateMandatoryOptions(e.data.roomId, e.data.flightDetails);
                    continueToBook(e.data.roomId, e.data.priceId);
                }
            });

            scope.$on('$destroy', () => {
                broker.unsubscribe('CompactRoomGrid');
            });

            function _findHotelRoomPrices(hotelData, findTemplate) {
                hotelData.forEach(({ Availability, nonInfants }) =>
                    Availability.forEach(({ BoardTypes }) =>
                        BoardTypes.forEach(({ Prices }) =>
                            Prices.forEach(Price => findTemplate(Price, nonInfants))
                        )
                    )
                );
            }

            function _restructureData() {
                //For the compact grid view let the usual room stuff happen and then restructure the data
                //in to the format we want.
                const hotelData = hotelRoomService.restructureData(scope.hotel);
                scope.roomGridData = hotelData;
                //set up array to hold the selected rooms, really only because of multiroom
                scope.selectedPrices = {};
                for (let i = 0; i < hotelData.length; i++) {
                    scope.selectedPrices[hotelData[i].Id] = (hotelData.length > 1 && hotelData[i].Availability[0])
                        ? hotelData[i].Availability[0].BoardTypes[0].Prices[0].Id : null;
                }
                if (hotelData.length > 0) {
                    if (scope.showCityTax && TRPCONFIG.Domain.EnableCityTax) {
                        let estabList = [];

                        _findHotelRoomPrices(hotelData, ({ Cost }, nonInfants) => estabList.push({
                            EstabId: scope.hotel.Id,
                            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                            TotalCost: Cost / (scope.priceMode === 0 ? nonInfants : 1)
                        }));

                    }

                    const totalRooms = _.reduce(_.map(hotelData, function(rr) { return rr.Availability.length; }), function(n, m) { return n + m; }, 0);
                    scope.moreRooms = totalRooms - (hotelData.length * scope.roomsToShow);
                    scope.totalNonInfants = scope.isKidsFree
                        ? occupancyService.getOnlyPayingIndividuals()
                        : _.reduce(hotelData, function(n, m) { return n + m.nonInfants; }, 0);
                }
            }

            function selectSingleRoom(roomId, priceId, roomIndex, roomInfo = {}) {
                if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !scope.holidayMode) {
                    checkMandatoryTransfers(roomInfo, roomId, priceId, roomIndex);
                } else {
                    continueToBook(roomId, priceId);
                }
            }

            function selectMultipleRooms() {
                if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !scope.holidayMode) {
                    const roomsWithMandatoryTransfer = mandatoryTransferService.getRoomsWithTransfers(scope.hotel, scope.roomGridData, scope.selectedPrices);
                    roomsWithMandatoryTransfer.length > 0 ? selectTransferForMultiRoom(roomsWithMandatoryTransfer) : pickRooms();
                } else {
                    pickRooms();
                }
            }

            function selectTransferForMultiRoom(rooms) {
                const priceMode = scope.priceMode;
                broker.publish('showModalAddFlightDetailsForMultiRooms', { rooms, priceMode });
            }

            function checkMandatoryTransfers(roomInfo, roomId, priceId, roomIndex) {
                const mandatoryTransfers = mandatoryTransferService.getTransfers(roomInfo.Extras);
                let showMandatoryExtrasModal = roomInfo.Extras ?
                                               mandatoryTransfers.length > 0 :
                                               false;
                const priceMode = scope.priceMode;
                const totalNonInfants = scope.totalNonInfants;
                showMandatoryExtrasModal ? broker.publish('showModalAddFlightDetails', { roomId, priceId, roomInfo, roomIndex, priceMode, totalNonInfants }) : continueToBook(roomId, priceId);
            }

            function continueToBook(roomId, priceId) {
                const isPriceIdArray = _.isArray(priceId);
                if (isPriceIdArray && priceId.length === 1) {
                    priceId = priceId.join();
                }

                analytics.trackEvent({ category: 'searches', action: 'optionsPage' });
                scope.selectedPrices[roomId] = priceId;
                cookieService.set('SelectedPrices', scope.selectedPrices[roomId]);
                cookieService.set('VoucherCode', '');
                cookieService.set('VoucherWarnMessage', '');

                pickRooms();
            }

            function pickRooms() {
                if (_.some(scope.selectedPrices, function(p) { return p == null; })) {
                    scope.showMessagePopup = true;
                } else {
                    const arr = _.map(scope.selectedPrices);
                    scope.selectRooms({ ids: arr });
                }
            }

            function toggleExtraRooms() {
                if (scope.showAllRooms) {
                    scrollService.scrollTo('#roomsPanel', { animate: true }).then(function() {
                            scope.showAllRooms = !scope.showAllRooms;
                    });
                } else {
                    scope.showAllRooms = !scope.showAllRooms;
                }
            }

            function openImageGallery(url, e) {
                e.preventDefault();

                scope.roomImages = [];
                scope.roomImages.push({ src: url });
                scope.showRoomImages = true;
            }

        }
    };
});
})();
